import { Injectable } from '@angular/core';

import {AlertController, App, Events, IonicApp, NavController, Platform, ToastController} from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { AppVersion } from '@ionic-native/app-version';



import {AngularFireDatabase} from "angularfire2/database";

import { AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../services/auth';

import { Device } from '@ionic-native/device';
import {PortalDataService} from "./portal-data";
import {LogService} from "../services/logger";
import {Observable} from "rxjs/Observable";

import { Network } from '@ionic-native/network';
import { ConnectivityService } from '../services/connectivity';

import {Validators} from "@angular/forms";

import { Badge } from '@ionic-native/badge';
import {FCM} from "@ionic-native/fcm";
import {SelfRankingPage} from "../pages/account/self-ranking/self-ranking";
import {MissionsListPage} from "../pages/missions/missions-list/missions-list";
import {TutorialPage} from "../pages/tutorial/tutorial";
import {LoginPage} from "../pages/login/login";
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';



interface deviceInterface {
    date?: string,
    id?: string,
    model?: string,
    cordova?: string,
    platform?: string,
    version?: string,
    manufacturer?: string,
    serial?: string,
    isVirtual?: boolean,
};

@Injectable()
export class UserData {
    _favorites: string[] = [];
    HAS_LOGGED_IN = 'hasLoggedIn';
    HAS_SEEN_TUTORIAL = 'hasSeenTutorial';
    USER_ID = 'userId';
    USER_DATA = 'userData';

    public session: any;
    public data: any;

    public sessionRef: any = false;
    public dataRef: any = false;
    public subscribeRef: any;

    public notifications: any;

    public inited: boolean = false;

    public userInfos: any;
    public deviceInfo: deviceInterface = {};

    public token: any = false;

    public fbReferences: any = {};
    public fbRegistries: any = {};
    public fbListReferences: any = {};
    public fbListsRegistries: any = {};
    public registriesInited: boolean = false;

    public registries : any = ["address","civility","identity","searchFilters","terminal","notifications"];
    public lists : any = ["certificates","experiences","formations","languages","missions"];
    public needPush:boolean = false;
    public delayedSyncTimeOut:any = false;

    public loggedOut:any;
    public anonymousPages:any = ['LoginPage','SignupPage','login','signup','n4-1','n4-3'];

    public connectivityRefresher:any;

    public is_contractual:boolean = false;

    public defaultRegistriesValues = {
        "settings":{
            "notifications":{
                "kinds":{
                    "important":true,
                    "news":true,
                },
                "ways":{
                    "email":true,
                    "push":true,
                    "sms":true,
                },
            },
            "appVersion": {
                "os":'',
                "v":'0.1',
                "b":'0.1',
            }
        },
        "searchFilters" : {

            location : {
                lng:0,
                lat:0,
                mode: "address",
                address:"",
                enabled:false,
                distance: 30
            },
            job : {
                enabled: false,
                jobs: []
            },
            sector : {
                enabled: false,
                sectors: {}
            },
            salary : {
                enabled:false,
                range:{
                    lower:9.88,
                    upper:20
                }
            },
            length : {
                enabled:false,
                range:{
                    lower:0,
                    upper:10
                }
            },
            order: 'date'
        }
    };



    constructor(
        public events: Events,
        public storage: Storage,
        public afDatabase: AngularFireDatabase,
        private afAuth: AngularFireAuth,
        public authService: AuthService,
        public device: Device,
        public appVersion: AppVersion,
        public portalService: PortalDataService,
        public logService: LogService,
        public connectivity: ConnectivityService,
        public platform: Platform,
        private fcm: FCM,
        public badge: Badge,
        public alertCtrl: AlertController,
        public toastCtrl: ToastController,
        protected app: App,
    ) {
        this.connectivityRefresher=false;
    }
    userSession(){
        var log = Date.now();
        var that = this;
        this.session = this.authService.getSession();
        if(!this.sessionRef || this.sessionRef.closed)
        {
            this.sessionRef = this.session.subscribe(
                (auth) => {
                    if (auth != null) {
                        var firsttime = false;
                        if(!that.token) {
                            firsttime=true;
                        }
                        //console.log(auth);
                        that.setToken(auth.uid);
                        that.token = auth.uid;
                        that.setLoggedIn();
                        that.logService.log('LOGGED IN '+that.token);
                        that.storage.set(that.HAS_LOGGED_IN, true);
                        that.events.publish('user:identified');

                        that.storage.get('fcmToken').then((value) => {
                            if(value) {
                                that.set('fcmToken', value);
                                that.storage.set('fcmToken',false);
                            }
                        });
                        that.afDatabase.object('/users/' + that.token + '/last_connection' ).set(Date.now());
                        /*if(firsttime)
                        {*/
                            that.logTerminal();
                        /*}*/
                    }
                    else {
                        that.logService.log("User is not connected");
                        that.logService.log('LOGGED OUT '+that.token);
                        that.storage.set(that.HAS_LOGGED_IN, false);
                        that.events.publish('user:unidentified');
                    }
                    console.log("SESSION",log-Date.now());
                }
            );
            return this.session;
        }
        else
        {
            return this.session;
        }
    }
    loggedInDestination()
    {
        var that = this;
        if(!that.get('availability'))
        {
            return "AvailabilityPage";
        }
        else if(!that.get('ranking'))
        {
            return "SelfRankingPage";
        }
        else
        {
            return "MissionsListPage";
        }
    }

    setLoggedIn()
    {
    }
    setLoggedOut()
    {
    }
    login(username: string, password: string): any {

        var promise = this.authService.login(username, password);
        var that = this;
        promise.then(auth => {
            that.setToken(auth.uid);
            that.token = auth.uid;
            that.setUsername(username);
            that.events.publish('user:login');
            //that.events.publish('user:identified');
        })
            .catch(err => {
                that.logService.log('LOGIN KO :'+err.message);
            });
        return promise;

    };

    signup(username: string, password: string, firstname:string = ""): any {

        var promise = this.authService.signup(username, password);
        var that = this;
        promise.then(auth => {
            that.setToken(auth.uid);
            that.token = auth.uid;
            that.events.publish('user:signup');
            //that.events.publish('user:identified');
            //that.set('civility/email',auth.email);
            that.afDatabase.object('/users/'+auth.uid+'/civility/email').set(auth.email);
            that.afDatabase.object('/users/'+auth.uid+'/civility/prenom').set(firstname);
            //that.events.publish('user:identified');
            //this.setUsername(username);
        })
            .catch(err => {
                that.logService.log('LOGIN KO :'+err.message);
            });
        return promise;

    };
    listen(reg,value,callback) {
        var dataRef = this.afDatabase.object('/users/' + this.token+'/'+reg);
        return dataRef.valueChanges().subscribe(data => {
            if(!value || value==data)
                callback(data);
        });
    }
    requireProvideAfterSync(){
        var that = this;
        /*
        we set portal serviec aware that he need to get informations from server after syncing
         */
        that.portalService.setNeedProvideFromServer(true);

    }
    load() {

        /*if (this.data && this.inited) {
            //return this.afDatabase.object('/users/' + this.token).valueChanges();
            return Observable.of(this.data);
        } else {*/
            if(this.connectivity.isOnline())
            {
                //console.log("ONLINE "+this.token);
                console.log("#1");
                this.stopConnectivityRefresher();
                if(this.token) {
                    console.log("#2");
                    if(this.needPush && this.connectivity.isOnline())
                    {
                        this.pushAsyncToFirebase();
                    }
                    if(!this.inited) {
                        console.log("#3");
                        this.inited = true;
                        this.initRegistries();
                        this.portalService.provideRequest('user-notifications', this.token);
                        this.dataRef = this.afDatabase.object('/users/' + this.token);
                        console.log("#4");
                        this.subscribeRef = this.dataRef.valueChanges().subscribe(data => {
                            console.log("#6");
                            this.data = data;
                            if (!this.data.searchFilters) {
                                this.set('searchFilters', this.defaultRegistriesValues.searchFilters);
                            }
                            if(this.data.is_contractual)
                                this.is_contractual = this.data.is_contractual;
                            this.storage.set("userData", this.data);
                        }, this);
                    }
                    console.log("#5");
                    return this.dataRef.valueChanges();
                }
                else {
                    console.log("##A");
                    return Observable.of(this.data);
                }
            }
            else
            {
                console.log("##B");
                if(this.token && !this.inited) {
                    var that = this;
                    var promise  = this.storage.get("userData"+this.token);
                    promise.then(function(data){
                        //console.log(data);
                        that.data = data
                    });
                    this.startConnectivityRefresher();
                    return Observable.fromPromise(
                        promise
                    );

                }
                else {
                    //this.startConnectivityRefresher();
                    return Observable.of(this.data);
                }
            }

        //}
    }
    startConnectivityRefresher(){
        if(!this.connectivityRefresher)
        {
            var that = this;
            //console.log('internet ko');
            this.connectivityRefresher = setInterval(function(){
                //console.log('internet test');
                that.presentToast('Vous semblez ne disposer d\'aucune connexion internet. Le fonctionnement de l\'application peut s\'en trouver dégradé.')
                that.load();
            },10000);
        }
    }
    stopConnectivityRefresher()
    {
        if(this.connectivityRefresher)
        {
            clearInterval(this.connectivityRefresher);
            this.connectivityRefresher = false;
            //console.log('internet ok');
        }
    }
    getUploadRoot()
    {
        return '/users/'+this.token+'/documents/';
    }

    pushAsyncToFirebase() {
        for(var i=0;i<this.registries.length;i++)
        {
            let key = this.registries[i];
            if(this.data[key])
            this.afDatabase.object('/users/' + this.token + '/'+key).set(this.data[key]);
        }
        for(var i=0;i<this.lists.length;i++)
        {
            let key = this.lists[i];
            if(this.data[key])
            this.afDatabase.object('/users/' + this.token + '/'+key).set(this.data[key]);
        }
        this.needPush = false;
        this.storage.set("offlineUpdates",false);
    }
    observable(registry) {
        if(registry.indexOf('/')>0)
        {
            var registries=registry.split('/');
            if(this.data && this.data[registries[0]] && this.data[registries[0]][registries[1]]) return Observable.of(this.data[registries[0]][registries[1]]);
        }
        else
            if(this.data && this.data[registry])
                return Observable.of(this.data[registry]);
            else {
                this.data[registry] = {};
                return Observable.of(this.data[registry]);
            }


    }
    get(registry) {
        if(registry.indexOf('/')>0)
        {
            var registries=registry.split('/');
            if(this.data && this.data[registries[0]] && this.data[registries[0]][registries[1]]) return this.data[registries[0]][registries[1]];
        }
        else
            if(this.data && this.data[registry]) return this.data[registry];
        return false;
    }

    getAsArray(registry) {
        var retArray = [];
        var registry = this.get(registry);
        if(!registry)return registry;

        for(let i=0;i<Object.keys(registry).length;i++)
        {
            let k = Object.keys(registry)[i];
            let object = registry[k];
            object['_key'] = k;
            retArray.push(object);
        }
        return retArray;
    }
    set(registry,data) {

        if(registry.indexOf('/')>0)
        {
            var registries=registry.split('/');
            if(!this.data[registries[0]])this.data[registries[0]]={};
            this.data[registries[0]][registries[1]]=data;

        }
        else
            this.data[registry]=data;

        this.storage.set("userData"+this.token, this.data);
        if(this.connectivity.isOnline()) {
            this.afDatabase.object('/users/' + this.token+'/'+registry).set(data);
            this.delayedTriggerPortalSync({});
        }
        else
        {
            this.storage.set("offlineUpdates",true);
            this.needPush = true;
        }
        this.portalService.markAsModified(
            'users',this.token,registry
        );
        return this.data;
    }
    push(registry,data) {
        this.afDatabase.list('/users/' + this.token+'/'+registry).push(data);
        this.delayedTriggerPortalSync({});
        this.portalService.markAsModified(
            'users',this.token,registry
        );
        return this.data;
    }
    localPush(registry,list,data) {
        var localRegistry=false;
        if(registry=="")
        {
            localRegistry = this.data;
        }
        else if(registry.indexOf('/')>0)
        {
            var registries=registry.split('/');
            if(!this.data[registries[0]])this.data[registries[0]]={};
            if(!this.data[registries[0]][registries[1]])this.data[registries[0]][registries[1]]={};
            localRegistry = this.data[registries[0]][registries[1]];
        }
        else {
            if (!this.data[registry]) this.data[registry] = {};
            localRegistry = this.data[registry];
        }
        if(!localRegistry[list])localRegistry[list]={};
        var key = this.uniqid();
        localRegistry[list][key]=data;
        this.storage.set("userData"+this.token, this.data);
        if(this.connectivity.isOnline()) {
            this.afDatabase.object('/users/' + this.token+'/'+registry+'/'+list+'/'+key).set(data);
            this.delayedTriggerPortalSync({});
        }
        else
        {
            this.storage.set("offlineUpdates",true);
            this.needPush = true;
        }
        this.portalService.markAsModified(
            'users',this.token,registry+'/'+list
        );
        return this.data;
    }
    setLocal(registry,data) {
        this.data[registry]=data;
        this.storage.set("userData"+this.token, this.data);
        return this.data;
    }
    update(registry,key,data) {

        if(registry.indexOf('/')>0)
        {
            var registries=registry.split('/');
            if(!this.data[registries[0]])this.data[registries[0]]={};
            if(!this.data[registries[0]][registries[1]])this.data[registries[0]][registries[1]]={};
            this.data[registries[0]][registries[1]][key]=data;
        }
        else
        {
            if(!this.data[registry])this.data[registry]={};
            this.data[registry][key]=data;
        }
        this.storage.set("userData"+this.token, this.data);
        if(this.connectivity.isOnline()) {
            let update = {};
            update[key]=data;
            this.afDatabase.object('/users/' + this.token+'/'+registry).update(update);
            this.delayedTriggerPortalSync({});
        }
        else
        {
            this.storage.set("offlineUpdates",true);
            this.needPush = true;
        }
        this.portalService.markAsModified(
            'users',this.token,registry+'/'+key
        );
        return this.data;
    }
    initRegistries()
    {
        var appciation = this;
        if(!this.registriesInited)
        {
            this.registriesInited = true;
            this.logService.log('Init firebase Registries');
            this.fbReferences['me'] = this.afDatabase.object('/users/'+this.token);
            /* set references and subscriber */
            for(var i=0;i<this.registries.length;i++)
            {
                let key = this.registries[i];
                //this.logService.log('Init firebase User '+key+' References');
                this.fbReferences[key] = this.afDatabase.object('/users/'+this.token+'/'+key);
            }
            for(var i=0;i<this.lists.length;i++)
            {
                let key = this.lists[i];
                //this.logService.log('Init firebase User '+key+' List');
                if(key=="formations" || key=="certificates" || key=="experiences")
                    this.fbListReferences[key] = this.afDatabase.list('/users/'+this.token+'/'+key,ref => ref.orderByChild('year'));
                else
                    this.fbListReferences[key] = this.afDatabase.list('/users/'+this.token+'/'+key);
            }

            this.registriesInited = true;
        }
    }
    setNotificationAsRead(notification)
    {
        if(notification.read == false)
        {
            this.data.notifications.unread=this.data.notifications.unread-1;
            this.set('notifications/unread',this.data.notifications.unread);
            notification.read = true;
            for(let y=0;y<this.data.notifications.list.length;y++)
            {
                if(this.data.notifications.list[y].id == notification.id)
                {
                    this.update('notifications/list',y,notification);
                }
            }
        }
    }
    /**
     *
     * This method fullfill the postulation form with the user capabilities which already exist in his CV
     *
     * @param requirements
     * @returns {any}
     */
    fullfillMissionRequirementForm(requirements)
    {
        if(!requirements || requirements === undefined) return requirements;

        var formations = this.get('formations');
        var certificates = this.get('certificates');
        var languages = this.get('languages');
        var experiences = this.get('experiences');

        if(!formations )formations=[];
        if(!certificates )certificates=[];
        if(!languages )languages=[];
        if(!experiences )experiences=[];

        if(requirements.diplomas)
            for(let i=0;i<requirements.diplomas.length;i++)
            {
                requirements.diplomas[i].validated=false;
                for(let y=0; y<Object.keys(formations).length; y++)
                {
                    let k = Object.keys(formations)[y];
                    if(
                        formations[k].level == requirements.diplomas[i].title
                        && (!requirements.diplomas[i].theme_title || requirements.diplomas[i].theme_title == formations[k].title)
                    )
                    {
                        requirements.diplomas[i].validated=true;
                    }
                }
            }
        if(requirements.certificates)
            for(let i=0;i<requirements.certificates.length;i++)
            {
                requirements.certificates[i].validated=false;
                for(let y=0; y<Object.keys(certificates).length; y++)
                {
                    let k = Object.keys(certificates)[y];
                    if(certificates[k].certificate+"" == requirements.certificates[i].id+"")
                    {
                        if(
                            !requirements.certificates[i].job
                            || (requirements.certificates[i].job && certificates[k].job
                                && requirements.certificates[i].job+"" == certificates[k].job+"")

                        ) {
                            requirements.certificates[i].validated = true;
                        }
                    }
                }
            }
        if(requirements.experiences)
            for(let i=0;i<requirements.experiences.length;i++)
            {
                requirements.experiences[i].validated=false;
                var cumulated_experiences = {};
                for(let y=0; y<Object.keys(experiences).length; y++)
                {

                    let k = Object.keys(experiences)[y];
                    if(!cumulated_experiences[experiences[k]['poste']])
                    {
                        cumulated_experiences[experiences[k]['poste']]=0;
                    }
                    cumulated_experiences[experiences[k]['poste']]+=experiences[k]['duree_month'];
                    /*if(
                        experiences[k].duree == requirements.experiences[i].length
                    )
                    {
                        requirements.experiences[i].validated=true;
                    }*/
                }
                if(cumulated_experiences[requirements.experiences[i].title] && cumulated_experiences[requirements.experiences[i].title]>=requirements.experiences[i].month_length)
                {
                    requirements.experiences[i].validated=true;
                }
            }
        if(requirements.languages)
            for(let i=0;i<requirements.languages.length;i++)
            {
                requirements.languages[i].validated=false;
                for(let y=0; y<Object.keys(languages).length; y++)
                {
                    let k = Object.keys(languages)[y];
                    if(languages[k].langue == requirements.languages[i].language)
                    {
                        requirements.languages[i].validated=true;
                    }
                }
            }
        return requirements;
    }

    getUserInformations(registry: any = false){
        if (this.fbRegistries[registry]) {
            return Observable.of(this.fbRegistries[registry]);
        } else {
            this.fbReferences[registry] = this.afDatabase.object('/users/'+this.token+'/'+registry);
            this.fbRegistries[registry] = {};
            var that = this;
            return this.fbReferences[registry].valueChanges().map(data => {
                this.logService.log('FB listener : '+registry+' changes');
                this.fbRegistries[registry]=data;
                return this.fbRegistries[registry];
            },this);
        }
    }
    getUserDbReference(registry: any = false){
        //console.log(this.fbReferences);
        if(!registry) return this.fbReferences['me'];
        else{
            return this.fbReferences[registry];
        }
    }
    getUserInformationsReference(registry: any = false){
        if (this.fbReferences[registry]) {
            return Observable.of(this.fbReferences[registry]);
        } else {
            this.fbReferences[registry] = this.afDatabase.object('/users/'+this.token+'/'+registry);
            return Observable.of(this.fbReferences[registry]);
        }
    }
    infos(registry: any = false){
       return this.fbRegistries[registry];
    }
    getUserDbListReference(registry: any = false){

        return this.fbListReferences[registry];

    }
    list(registry: any = false){
        return this.fbListsRegistries[registry];
    }
    checkVersion()
    {
        this.afDatabase.object('/users/'+this.token+'/settings/appVersion/ok').set('terminal');
        var that = this;
        try {

            this.afDatabase.object('/users/'+this.token+'/settings/appVersion/getat').set(Date.now());

            this.appVersion.getPackageName().then((version) => {
                that.afDatabase.object('/users/'+this.token+'/settings/appVersion/package').set(version);
            });
            this.appVersion.getVersionNumber().then((version) => {
                that.afDatabase.object('/users/'+this.token+'/settings/appVersion/version').set(version);
                that.afDatabase.object('appData/config/build').valueChanges().take(1).subscribe(function(data:any) {
                    if(data && data.appOutdatedVersion && data.appStrictOutdatedVersion){
                        /** floatify version to compare **/
                        let strVersion:any=version+"";
                        let versions = strVersion.split('.');
                        if(versions.length>2)
                            strVersion=parseFloat(versions[0]+'.'+versions[1]+versions[2]);

                        if(strVersion<=data.appStrictOutdatedVersion)
                        {
                            let alert = that.alertCtrl.create({
                                title:'Mise à jour nécessaire',
                                enableBackdropDismiss:false,
                                message: 'Votre version de Novaterim ('+version+') est trop ancienne. Mettez à jour vers la nouvelle version ('+data.appVersion+') pour profiter des dernières fonctionnalités.',
                                buttons: [{
                                    text: 'Mettre à jour',
                                    handler: () => {
                                        if(that.platform.is('ios'))
                                            window.open(data.appUrlIos,'_system', 'location=yes');
                                        else
                                            window.open(data.appUrlAndroid,'_system', 'location=yes');
                                    }
                                },
                                    {
                                        text: 'Annuler et déconnecter',
                                        handler: () => {
                                            that.logout();
                                            that.app.getRootNav().setRoot('LoginPage');
                                            that.app.getRootNav().popToRoot({});
                                        }
                                    }]
                            });
                            // now present the alert on top of all other content
                            alert.present();
                        }
                        else if(strVersion<=data.appOutdatedVersion)
                        {
                            let alert = that.alertCtrl.create({
                                title:'Mise à jour disponible',
                                enableBackdropDismiss:false,
                                message: 'Votre version de Novaterim ('+version+') est un peu ancienne. <br/>Nous vous conseillons de mettre à jour vers la nouvelle version ('+data.appVersion+') pour profiter des dernières fonctionnalités.',
                                buttons: [{
                                    text: 'Mettre à jour',
                                    handler: () => {
                                        if(that.platform.is('ios'))
                                            window.open(data.appUrlIos,'_system', 'location=yes');
                                        else
                                            window.open(data.appUrlAndroid,'_system', 'location=yes');
                                    }
                                },
                                    {
                                        text: 'Annuler ',
                                        handler: () => {
                                            //that.logout();
                                        }
                                    }]
                            });
                            // now present the alert on top of all other content
                            alert.present();
                        }
                    }
                });
            });
            this.appVersion.getVersionCode().then((version) => {
                that.afDatabase.object('/users/'+this.token+'/settings/appVersion/build').set(version);
            });

        }
        catch(e)
        {
            that.logService.log("LOG APP VERSION FAILED");
        }
    }

    //////
    logTerminal(){

        if(this.platform.is('cordova')) {
            this.checkVersion();
            this.deviceInfo.date = "now";
            this.deviceInfo.id = this.device.uuid;
            this.deviceInfo.model = this.device.model;
            this.deviceInfo.cordova = this.device.cordova;
            this.deviceInfo.platform = this.device.platform;
            this.deviceInfo.version = this.device.version;
            this.deviceInfo.manufacturer = this.device.manufacturer;
            this.deviceInfo.serial = this.device.serial;
            this.deviceInfo.isVirtual = this.device.isVirtual;
            var tkey = this.deviceInfo.platform + "-" + this.deviceInfo.id;

            if (tkey == "null-null") tkey = "web-browser";
            this.afDatabase.object('/users/' + this.token + '/terminal/' + tkey).set(this.deviceInfo);

        }

    }

    hasFavorite(sessionName: string): boolean {
        return (this._favorites.indexOf(sessionName) > -1);
    };

    addFavorite(sessionName: string): void {
        this._favorites.push(sessionName);
    };

    removeFavorite(sessionName: string): void {
        let index = this._favorites.indexOf(sessionName);
        if (index > -1) {
            this._favorites.splice(index, 1);
        }
    };


    logout(): void {
        this.token=false;
        this.session=false;
        this.storage.remove(this.HAS_LOGGED_IN);
        this.storage.remove('username');
        this.storage.remove(this.USER_ID);
        this.data = {};
        this.setToken(null);
        this.token = false;
        this.events.publish('user:logout');
        var promise = this.authService.logout();
        this.inited =false;
        this.subscribeRef.unsubscribe();
        this.registriesInited =false;
        //if(this.sessionRef)this.sessionRef.unsubscribe();
    };

    setUsername(username: string): void {
        this.storage.set('username', username);
    };
    getUsername(): Promise<string> {
        return this.storage.get('username').then((value) => {
            return value;
        });
    };

    hasLoggedIn(): Promise<boolean> {

        return this.storage.get(this.HAS_LOGGED_IN).then((value) => {
            return value === true;
        });
    };
    checkLoggedIn(navCtrl: any, route: string)
    {
        this.hasLoggedIn().then(function(data){
                if(!data) {
                    navCtrl.setRoot('LoginPage');
                    navCtrl.popToRoot({})
                }
            }
        );
    }
    checkHasSeenTutorial(): Promise<string> {
        return this.storage.get(this.HAS_SEEN_TUTORIAL).then((value) => {
            return value;
        });
    };

    getToken(): Promise<string> {
        return this.storage.get(this.USER_ID).then((value) => {
            return value;
        });
    }
    setToken(token: string): void {
        this.storage.set(this.USER_ID, token);
    };

    existingUserThread(mission){

        let messages = this.get('messages');//['mission'+mission.id]);
        let auth = messages &&
            messages['mission'+mission] &&
            messages['mission'+mission].messages ;
        if(!auth) return 0;
        else
            return Object.keys(messages['mission'+mission].messages).length;
    }
    getUserInfos()
    {
        var that = this;
        this.getToken().then(function(token){
            var userInfosRef  = that.afDatabase.object('/users/'+token+'');
            userInfosRef.valueChanges().subscribe(data => {

                that.userInfos = data;
            });
        });
        return this.userInfos;
    }
    mapUserInfos(container)
    {
        var that = this;
        this.getToken().then(function(token){
            var userInfos  = that.afDatabase.object('/users/'+token+'');
            userInfos.valueChanges().subscribe(data => {

                container = data;
            });
        });
    }
    triggerPortalSync(param)
    {
        var that = this;
        this.getToken().then(function(token){
            try {
                return that.portalService.syncUserData(token);
            }
            catch(exp)
            {
                that.logService.log('Error on sync ',exp);
            }
        });
    }
    delayedTriggerPortalSync(param)
    {
        // We delayed in a timer to be sur to not call url multiple time
        var that = this;
        if(this.delayedSyncTimeOut) clearTimeout(this.delayedSyncTimeOut);
        this.delayedSyncTimeOut = setTimeout(function(){
            return that.portalService.syncUserData(that.token);
        },2500);
    }
    geolocationError()
    {
        let alert = this.alertCtrl.create({
            title: 'La géolocalisation a échoué. Activez la géolocalisation dans les paramètres de votre terminal.',
            buttons: [{
                text: 'OK',
                handler: () => {

                }
            }]
        });
        // now present the alert on top of all other content
        alert.present();
    }
    uniqid(a = "",b = false){
        var c = Date.now()/1000;
        var d = c.toString(16).split(".").join("");
        while(d.length < 14){
            d += "0";
        }
        var e = "";
        if(b){
            e = ".";
            var f = Math.round(Math.random()*100000000);
            e += f;
        }
        return a + d + e;
    }
    tutorialPopin(feature)
    {
        var that = this;
        var key = 'tutorialPopin'+feature;
        var config = {
            'UserActivity':{
                title:'Suivi d\'activité',
                message: <any>
                    '<ion-icon ios="ios-globe" md="md-cash" color="primary" item-start center style="font-size:18rem"></ion-icon>'+
                    'La rubrique <strong>"Suivi d\'activité"</strong> vous permettra de retrouver l\'ensemble de vos candidatures en cours, ainsi que vos missions passées ou à venir.',
                button:'OK',
            },
            'UserCalendar':{
                title:'Calendrier',
                message: <any>
                    '<ion-icon ios="ios-globe" md="md-cash" color="primary" item-start center style="font-size:18rem"></ion-icon>'+
                'La rubrique <strong>"Calendrier"</strong> vous permet de visualiser les missions en cours ou à venir, et de déclarer les heures effectuées chaque jour en quelques instants.',
                button:'OK',
            }
        }
        this.storage.get(key).then((value) => {
            if(/*true ||*/ value !== true)
            {
                let alert = this.alertCtrl.create({
                    title: config[feature].title,
                    message: config[feature].message,
                    buttons: [{
                        text: config[feature].button,
                        handler: () => {
                            this.storage.set(key,true)
                        }
                    }]
                });
                alert.present();
            }
        });
    }
    isAvailable()
    {
        var availability = this.get('availability');
        if(!availability) return true;
        return availability.available;
    }
    setFcmToken(fcmToken)
    {
        if(this.token) {
            this.set('fcmToken', fcmToken);
        }
        else
        {
            this.storage.set('fcmToken', fcmToken);
        }
    }
    private presentToast(text) {
        let toast = this.toastCtrl.create({
            message: text,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }
    public getAvatar()
    {
        var documents = this.get('documents');
        if(documents && documents.avatar)
        {
            if(documents.avatar.type=='firebase')
            {
                return {
                    'loading':true,
                    'mode':'loading',
                    'url': 'assets/img/avatar-loading.svg'
                };
            }
            documents.avatar.loading=false;
            return documents.avatar;
        }
        var default_avatar_urls = {
            'man':'https://www.novaterim.com/uploads/default-man.jpg',
            'woman':'https://www.novaterim.com/uploads/default-woman.jpg'
        };
        var default_url = default_avatar_urls.woman;

        if(this.get('civility') && this.get('civility').civility=="mme")
            default_url = default_avatar_urls.woman;


            return {
                'loading':false,
                'mode':'default',
                'url': default_avatar_urls.man
            };
    }
    public isPeConnected()
    {

        if(this.get('poleEmploiId'))return true;
        else return false;
    }
    public isPeEnabled()
    {
        //return true;
        if(this.get('poleEmploiLink'))return true;
        else return false;
    }
}



// WEBPACK FOOTER //
// ./src/providers/user-data.ts